import axios from "@/utils/http"  //获取封装的axios
import { Message } from "element-ui"; //调用element-ui 的message功能

export default{
    namespaced:true,
    state:{
        getInfoList:null,
        getInfoById:null,   //根据id获取的文章详情
    },
    mutations:{
        //数据处理,将token放在本地存储里面
        // 获取数据
        getInfoList(state,list){
            state.getInfoList = list
        },
        // 根据id获取文章详情
        getInfoById(state,list){
            state.getInfoById = list
            console.log(state.getInfoById);
        }
    },
    actions:{
        //获取文章标题列表
        getInfoAction({commit},type){
            axios.post('/article/list/'+type).then(response =>{
                if (response.code === 200) {
                    commit('getInfoList',response.data)
                    Message({
                        message:response.message,
                        type:'success'
                    })
                }else{
                    Message({
                        message:response.message,
                        type:'error'
                    })
                }
            })
        },
        // 根据文章id获取文章详情
        getInfoByIdAction({commit},id){
            axios.post('/article/'+id).then(response =>{
                if (response.code === 200) {
                    commit('getInfoById',response.data)
                    Message({
                        message:response.message,
                        type:'success'
                    })
                }else{
                    Message({
                        message:response.message,
                        type:'error'
                    })
                }
            })
        }
    },
    getters:{

    }
}